import { render, staticRenderFns } from "./email-readonly.vue?vue&type=template&id=0296d2a2"
import script from "./email-readonly.vue?vue&type=script&lang=js"
export * from "./email-readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports